import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { login, exchange, useSettings, useRouter } from '@loyalup/core';
import { Layout, Button, Field, Form, Link, AuthPanel } from '@loyalup/ui';

import s from './Login.module.css';

const onLogin = (setLoading, setErrors, urls) => response => {
  const { errors, role, auth_token } = response;

  if (errors) {
    setErrors(errors);
    setLoading(false);
    return false;
  } else if (role === 'admin') {
    window.location = `${urls.admin}/login?t=${auth_token[0]}`;
    return false;
  } else {
    setTimeout(() => {
      window.location = '/';
    });
    return true;
  }
};

const onSubmit = (fields, setLoading, setErrors, urls) => {
  setLoading(true);
  setErrors({});
  login(fields, onLogin(setLoading, setErrors, urls));
};

const tokenEchange = (token, setLoading, setErrors, urls) => {
  setLoading(true);
  setErrors({});
  exchange(token, onLogin(setLoading, setErrors, urls));
};

const Login = () => {
  const [t] = useTranslation();
  const { urls } = useSettings();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [fields, setFields] = useState({ email: '', password: '' });
  const { useLocation } = useRouter();
  const location = useLocation();

  useEffect(() => {
    const tempAuthToken = new URLSearchParams((location || {}).search).get('t');
    if (tempAuthToken) tokenEchange(tempAuthToken, setLoading, setErrors, urls);
  }, [location, urls]);

  return (
    <Layout center title={t('Авторизация')}>
      <AuthPanel>
        <div className={s.root}>
          <div className={s.header}>
            <h1>{t('Авторизация')}</h1>
          </div>
          <Form onSubmit={() => onSubmit(fields, setLoading, setErrors, urls)}>
            <Field
              label={t('Е-мейл')}
              name="email"
              type="email"
              autoFocus
              disabled={loading}
              error={errors.email}
              value={fields.email}
              onChange={email => setFields({ ...fields, email })}
            />
            <Field
              label={t('Пароль')}
              name="password"
              type="password"
              disabled={loading}
              error={errors.password}
              value={fields.password}
              onChange={password => setFields({ ...fields, password })}
            />
            <Link to="/password/forgot">{t('Забыли пароль?')}</Link>
            <Button type="submit" fixedWidth={200} center loading={loading}>
              {t('Войти')}
            </Button>
          </Form>
          <p className={s.hint}>
            {t('Ещё нет аккаунта?')}
            <br />
            <Link to="/register">{t('Зарегистрироваться')}</Link>
          </p>
        </div>
      </AuthPanel>
    </Layout>
  );
};

export default Login;
